import { Box, Paper, Typography } from '@mui/material';
import { useTodaySessionsStyles } from '../styles';
import clsx from 'clsx';
import { useL10n } from '@uplift/hooks';

export const Welcome: React.FC = () => {
  const l10n = useL10n();
  const { classes } = useTodaySessionsStyles();

  return (
    <Paper className={classes.paperContainer}>
      <Box className={clsx(classes.paperContent, classes.contentStack)} textAlign="center">
        <Typography variant="h6" color="textSecondary">{l10n.onboarding.welcome.title}</Typography>
        <Typography color="textSecondary">{l10n.onboarding.welcome.upcomingSessions}</Typography>
      </Box>
    </Paper>
  );
};
